import { render, staticRenderFns } from "./brandManage.vue?vue&type=template&id=bbe75a18&scoped=true"
import script from "./brandManage.vue?vue&type=script&lang=js"
export * from "./brandManage.vue?vue&type=script&lang=js"
import style0 from "./brandManage.vue?vue&type=style&index=0&id=bbe75a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe75a18",
  null
  
)

export default component.exports